import base from './base'

let controller = 'projectRegister'
let action = null

const ProjectRegister = {
  async listProjectRegisters (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sortBy: query.sort || 'tid',
      ascending: query.ascending || false
    }
    Object.assign(querys, query)
    action = 'List'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async getProjectRegisterDetail (orderNumber) {
    if (!orderNumber) {
      throw new Error('OrderNumber为空')
    }
    action = `Detail/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getProjectRegisterByGID (gid) {
    if (!gid) {
      throw new Error('参数为空')
    }
    action = `GetDetailByGID/${gid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getDetailByProjectId (prjId) {
    if (!prjId) {
      throw new Error('参数为空')
    }
    action = `GetDetailByProjectId/${prjId}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getSupervisionPermissions (orderNumber) {
    if (!orderNumber) {
      throw new Error('OrderNumber为空')
    }
    action = `GetSupervisionPermissions/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async checkViewPermission (orderNumber) {
    action = `CheckViewPermission/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async addProjectRegister (request) {
    action = 'Create'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async updateProjectRegister (request) {
    let orderNumber = request.orderNumber
    if (!orderNumber) {
      throw new Error('提交数据不合法!orderNumber为空')
    }
    action = `Update/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: request
    }
    return base.request(reqModel)
  },

  async revokeProjectRegister (orderNumber) {
    if (!orderNumber) {
      throw new Error('OrderNumber为空')
    }
    action = `Revoke/${orderNumber}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async auditProjectRegister (orderNumber, pass = true) {
    action = `Audit/${orderNumber}/${pass}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },

  async preAuditProjectRegister (orderNumber, pass = true) {
    action = `PreAudit/${orderNumber}/${pass}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: null
    }
    return base.request(reqModel)
  },

  async getProjectRegisterMode (supervisorName, cityId, industryId) {
    if (!supervisorName) {
      throw new Error('监管人名称为空')
    }
    action = `GetProjectRegisterMode`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: {
        supervisorName,
        cityId,
        industryId
      }
    }
    return base.request(reqModel)
  },

}

export default ProjectRegister